module.exports = __webpack_public_path__ + "static/Amphora-41be3c4cba71a208cac1481d206506b7.jpg";